var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512.03 448",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#1f8dc7;}.b{fill:#1a2345;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M512,240c0,114.9-114.6,208-256,208a306.18,306.18,0,0,1-104.1-17.9,296.19,296.19,0,0,1-54.3,30.6C73.6,471.1,44.7,480,16,480A16,16,0,0,1,4.6,452.7h0l.3-.3c.3-.3.7-.7,1.3-1.4,1.1-1.2,2.8-3.1,4.9-5.7a192.67,192.67,0,0,0,15.2-21.6c10-16.6,19.5-38.4,21.4-62.9C17.7,326.8,0,285.1,0,240,0,125.1,114.6,32,256,32S512,125.1,512,240Z",
    transform: "translate(0.03 -32)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M276.14,117.56c6.75-6.75,16.78-7.64,22.44-2l81.84,81.84c5.66,5.66,4.77,15.69-2,22.44s-16.78,7.64-22.44,2l-9.43-9.43-52.9,60.19c4.13,19.33.7,41.31-10.72,61.55l-.83,1.47a20,20,0,0,1-12.39,9.58c-5.09,1.25-10.1.06-13.39-3.24L154,239.66c-3.3-3.29-4.5-8.23-3.24-13.38a19.82,19.82,0,0,1,9.58-12.4l1.47-.83c20.24-11.42,42.22-14.85,61.55-10.71l60.19-52.91L274.16,140C268.5,134.34,269.39,124.31,276.14,117.56ZM181.79,288.63l25.58,25.58L169.54,352A18.09,18.09,0,0,1,144,326.47Z",
    transform: "translate(0.03 -32)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinHover);
export default __webpack_public_path__ + "static/media/pinHover.da711f57b613de554e9dae874df90574.svg";
export { ForwardRef as ReactComponent };